<script >
import { ref, onBeforeMount } from 'vue-demi';
import { Rank } from '@fegobull/common-component';
import { PLATFORM_TYPE } from '../common/scheme';
import useCustomRank from './useCustomRank';
import useMarketRank from './useMarketRank';
import useChartData from './useChartData';
import useSelectStatus from './useSelectStatus';
import useRankCmp from './useRankCmp';
const __sfc_main = {};
__sfc_main.props = {
  theme: String,
  rankType: String,
  sort_id: [String, Number],
  showHeader: Boolean,
  increaseType: String,
  market: String,
  upDownColor: Number,
  language: Number,
  count: Number,
  customStocklist: Array,
  schemeType: String,
  platform: {
    type: String,
    default: PLATFORM_TYPE.MOOMOO
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = useEnv();
  const props = __props;

  // 定义一个股票列表
  const stockList = ref([]);

  /* 市场排行 */
  const {
    getMarketRank
  } = useMarketRank(props);

  /* 自定义排行 */
  const {
    isCustomRank,
    getCustomRank
  } = useCustomRank(props);

  /* 图表数据 */
  const {
    initChartData,
    chartDataMap
  } = useChartData(stockList, props.increaseType);

  /* 自选状态 */
  const {
    selfSelectedMap,
    initSelectStatus,
    setSelectStatus
  } = useSelectStatus(stockList);

  /* 组件配置 */
  const {
    headerConfig,
    itemClick,
    iconClick
  } = useRankCmp(props, setSelectStatus);
  onBeforeMount(async () => {
    if (isPreRender) {
      return;
    }
    stockList.value = isCustomRank.value ? await getCustomRank() : await getMarketRank();
    initChartData();
    initSelectStatus();
  });
  return {
    stockList,
    chartDataMap,
    selfSelectedMap,
    headerConfig,
    itemClick,
    iconClick
  };
};
__sfc_main.components = Object.assign({
  Rank
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div class="quote-rank-v2">
        <Rank
            :dataSource="stockList"
            :chartDataMap="chartDataMap"
            :selfSelectedMap="selfSelectedMap"
            :header="headerConfig"
            :upDownColor="upDownColor"
            :theme="theme"
            @itemClick="itemClick"
            @iconClick="iconClick"
        />
    </div>
</template>
<style lang="less" scoped>
.quote-rank-v2 {
    height: auto !important;
}
</style>
